var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSedanWindshieldOutside(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 164,
    viewBox: "0 0 389 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 101.5L26.5 94H34.5L29.5 101.5Z",
    stroke: "#FFFF00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367 106L369.5 98.5H362L367 106Z",
    stroke: "#FFFF00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.5 134.5L275 148L188 152.5L172.5 159H190.5L275 150.5L295.5 134.5ZM295.5 134.5L352.5 122L357 116.5L306 128L254 146.5L295.5 134.5Z",
    stroke: "#FFFF00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.499 6.5C296.499 9.7 160.499 5.16667 93.4993 2.5L31.4993 112C22.0007 138 31.4986 143.591 43.9993 147C98.9993 162 286.999 169 350.499 151.5C374.943 144.764 370.999 127.333 365.499 117L304.499 6.5Z",
    stroke: "#FFFF00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 134.5L137.5 143.5L64 141.5L49 145.5L64 149.5L138.5 145.5L148.682 137.5M152.5 134.5L110.5 133.5L100.5 134.5L148.682 137.5M152.5 134.5L197.5 137.5L240 145.5L193 140.5L148.682 137.5M152.5 134.5L148.682 137.5",
    stroke: "#FFFF00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362.499 67.0003C354.099 68.2003 353.665 80.167 354.499 86.0003C354.668 87.6006 358.998 99.4614 367.498 97.4998C377.898 95.0998 390.998 78.5 386.998 72.0003C383.498 62.9999 372.999 65.5003 362.499 67.0003Z",
    stroke: "#FFFF00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2362 60.9957C35.6362 62.1957 38.0017 65.9957 38.0007 78.9993C37.8316 80.5996 42.5007 97.9993 22.2367 91.4952C6.5 86.4442 -1.26333 72.4954 2.73667 65.9957C12 57.9995 16.7362 59.4957 27.2362 60.9957Z",
    stroke: "#FFFF00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedanWindshieldOutside);
export default __webpack_public_path__ + "static/media/sedan-windshield-outside.f89a6b2e3801b4727d9d10318eecc733.svg";
export { ForwardRef as ReactComponent };